import { Component } from "react";
import { Formik } from "formik";
import { FormattedMessage, injectIntl } from "react-intl";

import { ActionBar } from "../ActionBar";

import { intlShape } from "../../shapes";

import {
  apiErrorsContain,
  createNode,
  createNodeType,
  createTenant,
  findDefaultAdminTenant,
  findNodeTypes,
  isNotFoundError,
  loadCurrentUser,
  loadCurrentUserAdminTenants,
  loadNode,
} from "../../api";

import {
  CancelButton,
  SelectBox,
  SubmitButton,
  TextArea,
  TextInput,
  TypeaheadBox,
  Form,
} from "../Form";

import {
  goBack,
  isEmpty,
  navigateTo,
  showSuccess,
  handleUnknownErrors,
} from "../../utils";

import { withRules, rulesShape } from "../../context/RulesContext";

import { NodeTypeRules } from "../../rules";
import { apiShape, withApi } from "../../context";
import { Column, Container, Row } from "../Grid";
import BackButton from "../BackButton";

type Props = {
  api?: apiShape;
  intl: intlShape;
  match?: {
    params?: {
      id?: string;
    };
  };
  rules?: rulesShape;
};

type State = $TSFixMe;

export class NodeCreate extends Component<Props, State> {
  // eslint-disable-next-line react/no-unused-class-component-methods
  api: $TSFixMe;

  formActions: $TSFixMe;

  loadNode: $TSFixMe;

  constructor(props: Props) {
    super(props);
    /* istanbul ignore next */
    this.validateForm = this.validateForm.bind(this);
    this.renderForm = this.renderForm.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.api = props.api;
    this.loadNode = loadNode.bind(this);

    this.state = {
      nodeTypes: undefined,
      tenants: undefined,
      parent: undefined,
      defaultAdminTenant: undefined,
      user: undefined,
    };
  }

  componentDidMount() {
    const { intl, match } = this.props;
    this.loadData(match?.params?.id).catch((apiErrors) => {
      if (isNotFoundError(apiErrors)) {
        navigateTo("/404");
      } else {
        handleUnknownErrors(
          apiErrors,
          intl.formatMessage({ id: "api.error.unknown" }),
        );
      }
    });
  }

  onSubmit(values: $TSFixMe, actions: $TSFixMe) {
    const { intl } = this.props;
    this.submitData(values, actions).catch((apiErrors) => {
      const formErrors = {};
      // @ts-expect-error TS(2345) FIXME: Argument of type '"name"' is not assignable to par... Remove this comment to see the full error message
      if (apiErrorsContain(apiErrors, "taken", "name")) {
        (formErrors as $TSFixMe).name = intl.formatMessage({
          id: "api.error.node.taken",
        });
      }
      if (Object.keys(formErrors).length < apiErrors.length) {
        handleUnknownErrors(
          apiErrors,
          intl.formatMessage({ id: "api.error.unknown" }),
        );
      }
      actions.setErrors(formErrors);
      actions.setSubmitting(false);
    });
  }

  async submitData(values: $TSFixMe, actions: $TSFixMe) {
    let tenantId = null;
    let parentId = null;
    const { intl } = this.props;
    const { user, parent } = this.state;
    if (parent) {
      parentId = parent.id;
    }
    if (values.type.new) {
      if (this.state.tenants.length === 0) {
        tenantId = await createTenant({
          name: `${user.firstName} ${user.lastName}`,
        });
      } else if (values.tenant) {
        tenantId = values.tenant.id;
      } else {
        tenantId = this.state.defaultAdminTenant.id;
      }
      /* eslint-disable no-param-reassign */
      values.type.id = await createNodeType(values.type, tenantId);
    } else if (!values.type.tenantPublic) {
      // eslint-disable-next-line prefer-destructuring
      tenantId = values.type.tenantId;
    }
    await createNode(values, tenantId, parentId);
    actions.setSubmitting(false);
    showSuccess(intl.formatMessage({ id: "node_create.success_notification" }));
    goBack();
  }

  async loadData(parentNodeId: $TSFixMe) {
    const user = await loadCurrentUser();
    const tenants = await loadCurrentUserAdminTenants(user);
    const defaultAdminTenant = findDefaultAdminTenant(user, tenants);
    const nodeTypes = (
      await findNodeTypes({ include: "tenant,parent" })
    ).filter(
      (nodeType: $TSFixMe) =>
        !nodeType.tenantPublic ||
        (NodeTypeRules.specialNodeTypeCodes.indexOf(nodeType.code) < 0 &&
          NodeTypeRules.specialNodeTypeCodes.indexOf(nodeType.parentCode) < 0),
    );

    if (parentNodeId) {
      const parent = await this.loadNode(parentNodeId);
      this.setState({ parent });
    }
    this.setState({
      user,
      nodeTypes,
      tenants,
      defaultAdminTenant,
    });
    if (tenants && tenants.length > 1) {
      this.formActions.setFieldValue("tenant", defaultAdminTenant);
    }
    this.formActions.setFieldValue(
      "type",
      nodeTypes.find((t: $TSFixMe) => t.code === "undefined"),
    );
  }

  validateForm(values: $TSFixMe) {
    const { intl } = this.props;
    const errors = {};

    if (isEmpty(values.name) || isEmpty(values.name.trim())) {
      (errors as $TSFixMe).name = intl.formatMessage({
        id: "validation.name.mandatory",
      });
    } else if (values.name.length > 255) {
      (errors as $TSFixMe).name = intl.formatMessage(
        { id: "validation.name.too_long" },
        { characters: 255 },
      );
    } else if (/[,;/\\$?<>]/.test(values.name)) {
      (errors as $TSFixMe).name = intl.formatMessage({
        id: "validation.node_name.special_chars",
      });
    }

    if (
      !values.type ||
      isEmpty(values.type.name) ||
      isEmpty(values.type.name.trim())
    ) {
      (errors as $TSFixMe).type = intl.formatMessage({
        id: "validation.type.mandatory",
      });
    } else if (values.type.name.length > 255) {
      (errors as $TSFixMe).type = intl.formatMessage({
        id: "validation.type.too_long",
      });
    }
    return errors;
  }

  renderForm(props: $TSFixMe) {
    const { intl } = this.props;
    const { nodeTypes, tenants } = this.state;
    const { isSubmitting, values } = props;
    const typeInfo =
      values.type && values.type.new
        ? intl.formatMessage({ id: "node.info_type.new" })
        : null;

    this.formActions = props;

    const tenant =
      tenants && tenants.length > 1 && values.type && values.type.new ? (
        <SelectBox
          {...props}
          id="node-tenant"
          name="tenant"
          label={intl.formatMessage({ id: "label.tenant" })}
          options={tenants}
        />
      ) : null;

    return (
      <Form {...props}>
        <TextInput
          {...props}
          id="node-name"
          name="name"
          label={intl.formatMessage({ id: "label.name" })}
          required
          autoFocus
        />
        <TypeaheadBox
          {...props}
          id="node-type"
          name="type"
          info={typeInfo}
          label={intl.formatMessage({ id: "label.type" })}
          options={nodeTypes}
          canCreate
          required
        />
        {tenant}
        <TextArea
          {...props}
          name="description"
          label={intl.formatMessage({ id: "label.description" })}
        />
        <div className="btn-group">
          <SubmitButton id="create-node-submit" fetching={isSubmitting} />
          {/* @ts-expect-error TS(2322) FIXME: Type '{ id: string; disabled: any; }' is not assig... Remove this comment to see the full error message */}
          <CancelButton id="create-node-cancel" disabled={isSubmitting} />
        </div>
      </Form>
    );
  }

  render() {
    return (
      <Container>
        <Row>
          <Column>
            <BackButton />
          </Column>
        </Row>
        <Row>
          <Column>
            <ActionBar>
              <h1>
                <FormattedMessage id="node_create.header" />
              </h1>
            </ActionBar>
          </Column>
        </Row>
        <Row>
          <Column sm="6">
            <Formik
              validate={this.validateForm}
              onSubmit={this.onSubmit}
              initialValues={{}}
            >
              {this.renderForm}
            </Formik>
          </Column>
        </Row>
      </Container>
    );
  }
}

// @ts-expect-error TS(2345) FIXME: Argument of type 'FC<WithIntlProps<Props>> & { Wra... Remove this comment to see the full error message
export default withApi(withRules(injectIntl(NodeCreate)));
